const WHITELIST_URLS = ['/public/']

export const isWhitelistRoute = (url) => {
    if (WHITELIST_URLS.length && url) {
        for (const i = 0; i < WHITELIST_URLS.length; i++) {
            return url.includes(WHITELIST_URLS[i])
        }
    }
    return false
}